export default __webpack_public_path__ + "static/media/family-EN.bdebe5ea.png";